/**
 * Know Your Fit section behaviour:
 *  - the big counter pops in the first time it scrolls into view
 *
 * Adapted from the Zesty Snackz know-your-bitez.js. The inline-video player it
 * also carried was dropped along with the video row.
 */
function initCounters(root = document) {
  const counters = [...root.querySelectorAll('[data-kyf-reveal]:not([data-kyf-init])')];
  if (!counters.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('kyf-in');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.4 }
  );

  counters.forEach((counter) => {
    counter.setAttribute('data-kyf-init', '');
    observer.observe(counter);
  });
}

function init(root = document) {
  initCounters(root);
}

init();

document.addEventListener('shopify:section:load', (event) => init(event.target));
